import { Injectable } from '@angular/core';
import { Point } from 'pixi.js';

@Injectable({
  providedIn: 'root',
})
export class LocationHelperService {
  // public constructor() { }

  /**
   * get x and y in relation to the big world\
   */
  public getLocalCoordinates(x: number, y: number, roomSize: number, appSize: number): Point {
    if (!roomSize || !appSize) {
      throw new Error('roomSize and appSize must be greater than zero');
    }

    const halfRoomSize = roomSize / 2;
    const scale = roomSize / appSize; // Scale factor between world and local map

    // Shift (0,0) from the center to the top-left
    const shiftedX = x + halfRoomSize;
    const shiftedY = y + halfRoomSize;

    // Convert to local coordinates
    const localX = Math.floor(shiftedX / scale);
    const localY = Math.floor(shiftedY / scale);

    return new Point(localX, localY);
    // return new Point(x, y);
  }

  public getWorldCoordinates(x: number, y: number, roomSize: number, appSize: number): Point {
    if (!roomSize || !appSize) {
      throw new Error('roomSize and appSize must be greater than zero');
    }

    const halfRoomSize = roomSize / 2;
    const scale = roomSize / appSize; // Scale factor between local map and world

    // Convert from local to shifted world coordinates
    const shiftedX = x * scale;
    const shiftedY = y * scale;

    // Shift (0,0) from top-left back to center
    const worldX = shiftedX - halfRoomSize;
    const worldY = shiftedY - halfRoomSize;

    return new Point(worldX, worldY);
  } // endregion translation
}
